import React from 'react';
import { styled } from '@teko/ds-desktop';
import { LeftLineOutlined } from '@teko/ds-icon';

const StyledNavBarWithTitle = styled.div`
  display: flex;
  height: 3.5rem;
  background: #fff;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);

  &.detail {
    box-shadow: none;
  }
`;
const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Center = styled(FlexCenter)`
  flex: 1;
`;
const Left = styled(FlexCenter)`
  min-width: 3.5rem;
  height: 3.5rem;
  position: absolute;
`;
const NavBar = ({
  title,
  goBack
}) => {
  return /* @__PURE__ */ React.createElement(StyledNavBarWithTitle, null, goBack && /* @__PURE__ */ React.createElement(Left, null, /* @__PURE__ */ React.createElement(LeftLineOutlined, {
    size: 24,
    onClick: goBack,
    color: "#333"
  })), /* @__PURE__ */ React.createElement(Center, null, title));
};

export { NavBar };
